/*
 * Copyright (C) 2018 Frontier Developments PLC.
 */

import {Component, Vue} from 'vue-property-decorator';
import Utils from '@/services/utils';

/**
 * Home page view (component).
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
@Component({
    name: 'v-home',
})
export default class Home extends Vue {
    /**
     * @return {boolean}
     */
    public get isProduction(): boolean {
        return Utils.isProduction();
    }
}
